export const createRegistration = async (URL, payload) => {
  console.log("URL", URL);

  let response = await fetch(URL, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return response.json();
};
